import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { BranchEnvironmentVariable, getDefaultBranch } from '@utils/environment';

import { BranchEnvironmentStateType } from './branchEnvironment.interfaces';

const initialState: BranchEnvironmentStateType = {
	variables: getDefaultBranch(),
	isUpdated: false,
};

export const {
	actions: branchEnvironmentActions,
	reducer: branchEnvironmentReducer,
	name: branchEnvironmentName,
} = createSlice({
	name: 'branchEnvironment',
	initialState,
	reducers: {
		setBranchEnvironment(state, action: PayloadAction<BranchEnvironmentVariable>) {
			state.variables = action.payload;
			state.isUpdated = true;
		},
	},
});
